/*
 * transfer-booking.js — Airport transfer zone booking form.
 * Loaded only on airport-transfer pages (zone_flat mode). Namespaced; does not
 * touch any other tour page. Adds the zone variant and an optional return leg
 * as separate cart line items, then sends the customer to checkout.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initForm(config) {
    var form = document.getElementById(config.formId);
    if (!form || form.dataset.tfReady) return;
    form.dataset.tfReady = '1';

    // Never let the form do a native GET submit (no action / fetch-based).
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    var zoneSel    = form.querySelector('[data-transfer-zone]');
    var rtToggle   = form.querySelector('[data-tf-roundtrip]');
    var returnBox  = form.querySelector('[data-tf-return]');
    var totalEl    = form.querySelector('[data-tf-total]');
    var hintEl     = form.querySelector('[data-tf-total-hint]');
    var errorEl    = form.querySelector('[data-tf-error]');
    var submitBtn  = form.querySelector('[data-tf-submit]');
    var section    = form.closest('[data-section-id]');
    var sidebarPrice = section ? section.querySelector('[data-booking-live-price]') : null;
    var returnInputs = returnBox ? returnBox.querySelectorAll('[data-tf]') : [];
    var pickupSel    = form.querySelector('[data-tf="pickup"]');
    var ferryField   = form.querySelector('[data-tf-ferry-field]');
    var ferrySel     = form.querySelector('[data-tf="ferry"]');
    var flightField  = form.querySelector('[data-tf-flight-field]');
    var flightInput  = form.querySelector('[data-tf="flight"]');

    if (!zoneSel || !submitBtn) return;

    function isFerry() { return !!(pickupSel && pickupSel.value === 'Ferry'); }

    function zoneCents() {
      var opt = zoneSel.options[zoneSel.selectedIndex];
      return opt ? (parseInt(opt.getAttribute('data-cents'), 10) || 0) : 0;
    }
    function roundTrip() { return !!(rtToggle && rtToggle.checked); }

    function recalc() {
      var z = zoneCents();
      var total = z;
      if (roundTrip()) total += z;

      if (totalEl) totalEl.textContent = formatMoney(total);
      if (sidebarPrice) sidebarPrice.textContent = formatMoney(total);

      if (hintEl) {
        if (roundTrip()) {
          hintEl.textContent = '2 transfers (round trip) — ' + formatMoney(z) + ' each leg';
          hintEl.hidden = false;
        } else {
          hintEl.hidden = true;
        }
      }
    }

    function syncReturn() {
      var on = roundTrip();
      if (returnBox) returnBox.hidden = !on;
      Array.prototype.forEach.call(returnInputs, function (el) {
        el.disabled = !on;
        if (on) {
          el.setAttribute('required', 'required');
        } else {
          el.removeAttribute('required');
          el.value = '';
        }
      });
      recalc();
    }

    // When pick-up is Ferry: show the Ferry company select (required) and hide
    // the Flight number field (drop its `required` so reportValidity passes).
    // When pick-up is Airport: the reverse.
    function syncPickup() {
      var ferry = isFerry();
      if (ferryField) ferryField.hidden = !ferry;
      if (ferrySel) {
        if (ferry) {
          ferrySel.setAttribute('required', 'required');
        } else {
          ferrySel.removeAttribute('required');
          ferrySel.value = '';
        }
      }
      if (flightField) flightField.hidden = ferry;
      if (flightInput) {
        if (ferry) {
          flightInput.removeAttribute('required');
        } else {
          flightInput.setAttribute('required', 'required');
        }
      }
    }

    zoneSel.addEventListener('change', recalc);
    if (rtToggle) rtToggle.addEventListener('change', syncReturn);
    if (pickupSel) pickupSel.addEventListener('change', syncPickup);

    syncReturn();
    syncPickup();
    recalc();

    submitBtn.addEventListener('click', function () {
      if (errorEl) errorEl.hidden = true;
      if (!form.reportValidity()) return;

      function val(key) {
        var el = form.querySelector('[data-tf="' + key + '"]');
        return el ? el.value.trim() : '';
      }

      var zoneId = parseInt(zoneSel.value, 10);
      var base = {
        'Full name': val('fullname'),
        'WhatsApp number': val('whatsapp'),
        'Hotel': val('hotel'),
        'Number of suitcases': val('bags')
      };
      var notes = val('notes');
      if (notes) base['Special requests'] = notes;

      var rt = roundTrip();
      var items = [];

      var outbound = Object.assign({}, base, {
        'Trip': rt ? 'Round trip' : 'One-way',
        'Leg': 'Airport → Hotel',
        'Pick-up location': val('pickup'),
        'Transfer date': val('date'),
        'Pickup time': val('time')
      });
      if (isFerry()) {
        outbound['Ferry company'] = val('ferry');
      } else {
        outbound['Flight number'] = val('flight');
      }
      items.push({ id: zoneId, quantity: 1, properties: outbound });

      if (rt) {
        var ret = Object.assign({}, base, {
          'Trip': 'Round trip',
          'Leg': 'Hotel → Airport',
          'Transfer date': val('rdate'),
          'Pickup time': val('rtime'),
          'Flight number': val('rflight')
        });
        items.push({ id: zoneId, quantity: 1, properties: ret });
      }

      submitBtn.disabled = true;
      var originalHtml = submitBtn.innerHTML;
      submitBtn.textContent = 'Processing…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHtml;
        if (errorEl) {
          errorEl.textContent = 'Sorry, something went wrong. Please try again or book via WhatsApp.';
          errorEl.hidden = false;
        }
      });
    });
  }

  function init() {
    var configs = document.querySelectorAll('[data-transfer-config]');
    Array.prototype.forEach.call(configs, function (node) {
      try { initForm(JSON.parse(node.textContent)); } catch (e) { /* noop */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
